import { RegistrationType } from '@la/types';
// Determines if user is registered as free agent staff or team staff for the program/team
export const isExistingStaff = (userRegistrations, programId, userId, teamId) => {
    const existingRegistration = userRegistrations.find((registration) => {
        let matchingType = false;
        if (teamId) {
            matchingType =
                (registration.registrationType === RegistrationType.Staff ||
                    registration.registrationType === RegistrationType.Team) &&
                    teamId === registration.teamIdOg;
        }
        else {
            matchingType =
                registration.registrationType === RegistrationType.StaffFreeAgent;
        }
        return (matchingType &&
            registration.programId === programId &&
            registration.registrationStatus === 'REGISTERED' &&
            registration.registeringUserId === userId &&
            !registration.deleted);
    });
    return !!existingRegistration;
};
